import { Routes, Route, Navigate } from 'react-router-dom';
import { Home, Preview, DocumentViewer } from './pages';
import { Nav, Footer } from './components';
import styles from './App.module.scss';

function App() {
  return (
    <div className={styles.app}>
      <Nav />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/preview' element={<Preview />} />
        <Route path='/docs/:slug' element={<DocumentViewer />} />
        <Route path='/docs/*' element={<Navigate to="getting-started" replace />} />
        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
